import React from 'react'

import { TYPES } from './helpers'
import { initialState, treeReducer, Actions } from './reducer'

export { TYPES } from './helpers'

type TreeStateProviderType = {
  state: Record<string, boolean>
  dispatch: (payload: any) => void
  Actions: typeof Actions
}

const TreeStateContexts = Object.values(TYPES).reduce((acc, curr) => {
  acc[curr] = React.createContext<TreeStateProviderType>(null)
  return acc
}, {})

const TreeStateProvider = ({ type, children }) => {
  const [state, _dispatch] = React.useReducer(treeReducer, initialState(type))

  const dispatch: TreeStateProviderType['dispatch'] = React.useCallback(
    payload => {
      // @ts-ignore
      _dispatch({ ...payload, _type: type })
    },
    [type]
  )

  const Context = React.useMemo(
    () => TreeStateContexts[type] as React.Context<TreeStateProviderType>,
    [type]
  )

  return (
    <Context.Provider value={{ state, dispatch, Actions }}>
      {children}
    </Context.Provider>
  )
}

export default TreeStateProvider

export const useTreeState = (type: string) =>
  React.useContext(TreeStateContexts[type]) as TreeStateProviderType
